import { User } from '../types';

/** Check if the user has an effective feature/action capability from allowed_features. */
export function hasCapability(user: User | null | undefined, featureKey: string): boolean {
  if (!user?.allowed_features) return false;
  return user.allowed_features.includes(featureKey);
}

/** Feature capability OR assigned project PM hard exception. */
export function hasCapabilityOrProjectPm(
  user: User | null | undefined,
  featureKey: string,
  projectPmId?: number | null,
): boolean {
  if (hasCapability(user, featureKey)) return true;
  if (user?.id != null && projectPmId != null && Number(user.id) === Number(projectPmId)) {
    return true;
  }
  return false;
}

// Action capability keys (mirror backend feature_access.py)
export const CAP = {
  CREATE_PROJECT: 'create_project',
  UPDATE_PROJECT: 'update_project',
  ASSIGN_ENGINEERS: 'assign_engineers',
  CREATE_PROJECT_REVISION: 'create_project_revision',
  VIEW_ALL_PROJECTS: 'view_all_projects',
  VIEW_PROJECT_BUDGETS: 'view_project_budgets',
  MANAGE_WP_PERMISSIONS: 'manage_wp_permissions',
  MANAGE_CLIENTS: 'manage_clients',
  SALES_TOOLS: 'sales_tools',
  CLIENT_MANAGEMENT: 'client_management',
  ANALYTICS: 'analytics',
  LEADS: 'leads',
  PROPOSALS: 'proposals',
  AI_EXTRACT_CLIENT: 'ai_extract_client',
  DCC_CONFIG: 'dcc_config',
  CREATE_DOCUMENT: 'create_document',
  UPDATE_DOCUMENT: 'update_document',
  CANCEL_DOCUMENT: 'cancel_document',
  CREATE_DOCUMENT_REVISION: 'create_document_revision',
  EDIT_REVISION_WORKFLOW: 'edit_revision_workflow',
  CONFIGURE_DOCUMENT: 'configure_document',
  ASSIGN_BACKUP_FOR_OTHERS: 'assign_backup_for_others',
  VIEW_MANAGE_BACKUPS: 'view_manage_backups',
  DOCUMENT_CONTROLLER_ACTIONS: 'document_controller_actions',
  SEND_TRANSMITTAL: 'send_transmittal',
  MANAGE_TRANSMITTALS: 'manage_transmittals',
  MANAGE_SANDBOXES: 'manage_sandboxes',
  MANAGE_LCMS: 'manage_lcms',
  DELETE_LCM: 'delete_lcm',
  HR_ADMIN_ACTIONS: 'hr_admin_actions',
  MANAGE_CV_BANK: 'manage_cv_bank',
  DELETE_CV: 'delete_cv',
  UPDATE_PAID_LEAVE: 'update_paid_leave',
  ADJUST_NEGATIVE_HOLIDAY: 'adjust_negative_holiday',
  UPDATE_COMPANY_CONFIG: 'update_company_config',
  MANAGE_OTHERS_TIMESHEETS: 'manage_others_timesheets',
  SUBMIT_TIME_OFF_FOR_OTHERS: 'submit_time_off_for_others',
  APPROVE_TIME_OFF: 'approve_time_off',
  CREATE_USER: 'create_user',
  UPDATE_USER: 'update_user',
  LIST_ALL_USERS: 'list_all_users',
  MANAGE_THIRD_PARTIES: 'manage_third_parties',
  MANAGE_ROLES: 'manage_roles',
  // Page features used for routes
  USER_MANAGEMENT: 'user_management',
  GENERAL_CONFIG: 'general_config',
  HR: 'hr',
  EXPENSES: 'expenses',
  FEATURE_ACCESS: 'feature_access',
  CFOS: 'cfos',
  TIMESHEET_CUSTOM_CATEGORIES: 'timesheet_custom_categories',
  AI_ASSISTANT: 'ai_assistant',
  PDF_EDITOR: 'pdf_editor',
  HELP: 'help',
  WC2026: 'wc2026',
  CLIENT_FEEDBACK: 'client_feedback',
  MY_DOCUMENTS: 'my_documents',
} as const;
